import { BMDivider, BMPrimitives, BMText } from "@traveloka/district-bloom";
import BMView from "../../View/BMView";

import IcPaymentBalanceTransfer16 from "@traveloka/icon-kit-web/react/IcPaymentBalanceTransfer16";
import { StyleProp, StyleSheet, ViewStyle } from "react-native";
import { useMobileContentResource } from "../../../core/resource/MobileResourceProvider";

type Props = {
  date: string;
  totalAmount: string;
  items: Array<{ label: string; value: string }>;
  style?: StyleProp<ViewStyle>;
};

export default function TotalSpendingCard(props: Props) {
  const { totalAmount, items, date, style } = props;
  const { CorporateTransactionDataAnalytics: cr } = useMobileContentResource();

  return (
    <BMView style={[styles.container, style]}>
      <BMView spacing="sm">
        <BMView row spacing="xs">
          <IcPaymentBalanceTransfer16
            color={BMPrimitives.BMBrand.productFinancialServices}
          />
          <BMText variant="uiNormal" ink="BMStyleTextInkSecondary">
            {cr.totalSpending}
          </BMText>
        </BMView>
        <BMView>
          <BMText variant="titleNormal">{totalAmount}</BMText>
          <BMText variant="uiNormalLi" ink="BMStyleTextInkSecondary">
            {date}
          </BMText>
        </BMView>
      </BMView>
      <BMView spacing="xs">
        {items.map((item, index) => (
          <BMView key={`${item.label}-${index}`} spacing="xs">
            {index !== 0 ? (
              <BMDivider
                type="SUBTLE"
                orientation="HORIZONTAL"
                length="STRETCH"
              />
            ) : null}
            <BMView flex row align="center" justify="between" spacing="xs">
              <BMText variant="uiNormalLi" ink="BMStyleTextInkSecondary">
                {item.label}
              </BMText>
              <BMText variant="uiNormalLi" ink="BMStyleTextInkSecondary">
                {item.value}
              </BMText>
            </BMView>
          </BMView>
        ))}
      </BMView>
    </BMView>
  );
}

const styles = StyleSheet.create({
  container: {
    gap: BMPrimitives.BMSize.xl3,
  },
});
